const selectors = {
  body: 'body',
  main: '[data-main]',
  header: '[data-site-header]',
  shopifySection: '.shopify-section',
  preventTransparentHeader: '[data-prevent-transparent-header]',
};
const classes = {
  transparentHeader: 'transparent-header',
  siteHeaderTransparent: 'site-header--transparent',
  hasTransparentHeader: 'has-transparent-header',
};

const attributes = {
  dataTransparent: 'data-transparent',
};

const initTransparentHeader = () => {
  // Determine what is the first
  const body = document.querySelector(selectors.body);
  const header = body.querySelector(selectors.header);
  const headerTransparent = header.getAttribute(attributes.dataTransparent) === 'true';
  const firstSection = body.querySelector(selectors.main).children[0];

  if (!firstSection) {
    return;
  }

  const preventTransparentHeader = firstSection.querySelector(`${selectors.preventTransparentHeader}:first-of-type`);
  isHeaderTransparent = headerTransparent && firstSection.classList.contains(classes.transparentHeader) && !preventTransparentHeader;

  // Set transparent header class
  if (isHeaderTransparent) {
    header.classList.add(classes.siteHeaderTransparent);
    body.classList.add(classes.hasTransparentHeader);
  } else {
    header.classList.remove(classes.siteHeaderTransparent);
    body.classList.remove(classes.hasTransparentHeader);
  }
};

export default initTransparentHeader;
